import { Check, X } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { cn } from '@/lib/utils'

const RULES = [
  { key: 'min_length', rule: /^.{8,}$/ },
  { key: 'uppercase', rule: /[A-Z]/ },
  { key: 'lowercase', rule: /[a-z]/ },
  { key: 'special_char', rule: /[^A-Za-z0-9]/ },
  { key: 'digit', rule: /[0-9]/ }
] as const

export function PasswordRequirements({ password }: { password: string }) {
  const { t } = useTranslation('settings')

  return (
    <div className="rounded-2xl bg-muted/60 p-4">
      <p className="mb-3 text-sm font-semibold text-ink">
        {t('form.password_requirements')}
      </p>
      <ul className="space-y-2">
        {RULES.map(({ key, rule }) => {
          const ok = rule.test(password)
          return (
            <li
              key={key}
              className={cn(
                'flex items-center gap-2 text-sm transition-colors',
                ok ? 'text-primary' : 'text-muted-foreground'
              )}
            >
              <span
                className={cn(
                  'flex h-5 w-5 items-center justify-center rounded-full',
                  ok ? 'bg-primary text-white' : 'bg-ink/10 text-ink/40'
                )}
              >
                {ok ? (
                  <Check className="h-3 w-3" strokeWidth={3} />
                ) : (
                  <X className="h-3 w-3" strokeWidth={3} />
                )}
              </span>
              {t(`form.requirement.${key}`)}
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export const PASSWORD_REGEX =
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).{8,}$/
